<div class="modal-header">
  <h4 class="modal-title">
    @if (isEdit) {
      Update Business
    } @else {
      Add Business
    }
  </h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <div class="container-fluid p-2">
    <div class="d-grid grid-md-2-col gap-3">
      <!-- <mat-slide-toggle class="mat-slide-toggle-lg mb-2" [hideIcon]="true" name="active">Active</mat-slide-toggle> -->
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="business().Name" id="name" placeholder="Name" />
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="business().Tin" id="tin" placeholder="TIN No." />
        <label for="tin" class="form-label">TIN No.</label>
      </div>
      <div class="form-floating">
        <select class="form-select" id="floatingSelect" placeholder="Business Type">
          @for (b of BUSINESS_TYPE; track b) {
            <option [value]="b">{{ b }}</option>
          }
        </select>
        <label for="businessType">Business Type</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <input type="text" required class="form-control" [(ngModel)]="business().Directors" id="directors" placeholder="Directors" />
        <label for="directors" class="form-label">Directors</label>
      </div>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Year End</mat-label>
        <mat-select [(ngModel)]="business().YearEndMonth" [disabled]="isEdit" name="yearEnd">
          @for (m of allMonths; track m) {
            <mat-option [value]="m">{{ sharedService.formatMonth(m, 'long') }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="w-100">
        <mat-label>SSM Expiry Date</mat-label>
        <input matInput [min]="minDate" [matDatepicker]="ssmExpiryDate" name="ssmExpiryDate" [(ngModel)]="business().SsmExpiryDate" />
        <mat-datepicker-toggle matSuffix [for]="ssmExpiryDate"></mat-datepicker-toggle>
        <mat-datepicker #ssmExpiryDate></mat-datepicker>
      </mat-form-field>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="business().Brn" id="brn" placeholder="BRN No." />
        <label for="brn" class="form-label">BRN No.</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="business().OldRegNo" id="oldRegNo" placeholder="Old Reg No." />
        <label for="oldRegNo" class="form-label">Old Reg No.</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="business().Sst" id="sst" placeholder="SST No." />
        <label for="sst" class="form-label">SST No.</label>
      </div>
      <div class="form-floating">
        <input type="text" required class="form-control" [(ngModel)]="business().Ttx" id="ttx" placeholder="TTX No." />
        <label for="ttx" class="form-label">TTX No.</label>
      </div>
      <div class="form-floating full-width-grid-item">
        <textarea class="form-control" [(ngModel)]="business().Remark" placeholder="Remark" id="remark" style="height: 100px"></textarea>
        <label for="remark">Remark</label>
      </div>
      <mat-slide-toggle class="full-width-grid-item mat-slide-toggle-lg" [hideIcon]="true" [(ngModel)]="business().RequireConsentForm" name="requireConsentForm">Require Consent Form</mat-slide-toggle>
    </div>
    <div class="mt-3 d-flex justify-content-end gap-2">
      <button class="btn btn-light" (click)="resetBusiness()">Reset</button>
      <button class="btn btn-primary" (click)="addOrUpdateBusiness()">
        @if (isEdit) {
          Update
        } @else {
          Add
        }
      </button>
    </div>
  </div>
</div>
